import React from "react";
import "../App.css";

export default function Hero() {
  const whatsappNumber = "918660426964"; // <-- Uses your number

  return (
     <section id="home" className="hero">
      <div className="hero-content">
        <h1>Find Your Perfect Property</h1>
        <p>Premium Residential & Commercial Properties Across Bangalore</p>

        {/* WhatsApp Button */}
        <a
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noreferrer"
          className="hero-btn"
        >
          Chat on WhatsApp
        </a>
      </div>
    </section>
  );
}
